import { TABLA_DETALLE_POR_CONDICION_LINEA_12 } from '../../../../../config/tables'
import { TablaDetallePorCondicionLinea12Service } from '../../../../../models/movimiento/distribucionDetallePorCondicion/Tabla_detalle_por_condicion_linea_12'
import { COLUMNS_DETALLE_POR_CONDICION_LINEA_12, COLUMNS_DETALLE_POR_CONDICION_LINEA_12_TO_PRINT } from './constantesDetallePorCondicionLinea12'
import { pdfCustomToolbarGenerator } from '../../../../../models/tools/generarPdf'

export function actualizarDatosParaMuiTable () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_DETALLE_POR_CONDICION_LINEA_12
    })
    const promiseTablaDetallePorCondicionLinea12 = TablaDetallePorCondicionLinea12Service.getDataTablaDetallePorCondicionLinea12()
    const promiseTablaDetallePorCondicionLinea12Total = TablaDetallePorCondicionLinea12Service.getDataTablaDetallePorCondicionLinea12Total()
    Promise.all([promiseTablaDetallePorCondicionLinea12, promiseTablaDetallePorCondicionLinea12Total]).then(callback)
    function callback (dataArray) {
      const dataCombinada = dataArray[0].filas || []
      const filaTotalArreglada = dataArray[1].filas[0]
      filaTotalArreglada['cereal'] = 'Total'
      dataCombinada.push(filaTotalArreglada)
      const customToolbar = pdfCustomToolbarGenerator(
        'Distribución Por Condición Sector 1-2',
        dataCombinada,
        COLUMNS_DETALLE_POR_CONDICION_LINEA_12_TO_PRINT,
        'portrait')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_DETALLE_POR_CONDICION_LINEA_12,
          data: dataCombinada,
          title: `Distribución Por Condición Sector 1-2`,
          isLoading: false,
          fixed2Decimales: true,
          extraOptions: { customToolbar, print: false, pagination: false }
        },
        id: TABLA_DETALLE_POR_CONDICION_LINEA_12
      })
    }
  }
}
